import React from 'react';
import { Table, Empty, Tooltip ,Tag,Typography} from 'antd';
const { Text } = Typography;

export default function Resumen(props) {

    const _liStyle = {fontWeight:'bold'}

    return (
        <div>
            <Table
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText:
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description='No se encontraron datos'
                        />
                }}
                
                columns={[
                    {
                        title: 'Metodo de Pago',
                        dataIndex: 'metodoPago',
                        key: 'metodoPago',
                        align: 'center',
                
                    },
                 
                    {
                        title: 'Total (SOLES)',
                        dataIndex: 'total',
                        key: 'total',
                        align: 'right',
                        width: 190,
                        render: (data) => (
                            <span>S/ {data.toFixed(2)}</span>
                        )

                    }

                ]}

                footer={(e) =>  <span style={_liStyle}> TOTAL: S/  { (e.reduce((a, b) => a + (b["total"] || 0), 0)).toFixed(2)}</span>}
            />
        </div>
    );
}